export enum MenuStyle {
  default = 'default',
  tabs = 'tabs',
  tags = 'tags'
}
